"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.localLogger = exports.ProductListWithTranslations = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _defaultTranslations = require("../../../constants/defaultTranslations");
var _logger = require("../../../logger");
var _jsxRuntime = require("react/jsx-runtime");
/* istanbul ignore file -- container */

const localLogger = exports.localLogger = _logger.mainLogger.createChild('ProductListWithTranslations');
const onError = error => localLogger.error(new Error('ProductList fetching failed', {
  cause: error
}));
const ProductListWithTranslations = ({
  translations,
  children,
  withTranslationsProvider
}) => {
  const {
    language
  } = (0, _i18n.useTranslationsWithNamespaces)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  if (!withTranslationsProvider) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
      namespace: _defaultTranslations.translationsNamespace,
      children: children
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
    language: language,
    defaultTranslationsWithNamespaces: {
      [_defaultTranslations.translationsNamespace]: _defaultTranslations.defaultTranslations
    },
    translationsWithNamespaces: translations ? {
      [_defaultTranslations.translationsNamespace]: translations
    } : undefined,
    clientFetchConfiguration: {
      tenant,
      baseUrl: staticApiUrl,
      onError
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
      namespace: _defaultTranslations.translationsNamespace,
      children: children
    })
  });
};
exports.ProductListWithTranslations = ProductListWithTranslations;
